import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Users, Settings, FileText, Check, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

const STEPS = [
  { key: "employees", label: "Cadastrar Colaboradores", desc: "Adicione seus colaboradores PF e PJ", icon: Users, path: "/company/employees", checkFn: (s) => s.total_employees > 0 },
  { key: "settings", label: "Configurar Fluxo de Pagamento", desc: "Defina datas e aprovação", icon: Settings, path: "/company/settings", checkFn: () => true },
  { key: "fechamento", label: "Primeiro Fechamento", desc: "Feche o mês e gere boletos", icon: FileText, path: "/company/fechamento", checkFn: (s) => s.has_closing },
];

export default function GettingStarted({ stats }) {
  const navigate = useNavigate();
  if (!stats) return null;

  const hasEmployees = (stats.total_employees || 0) > 0;
  const hasClosed = (stats.total_anticipations || 0) > 0 || stats.has_closing;

  if (hasEmployees && hasClosed) return null;

  return (
    <Card className="border-blue-500/20 bg-gradient-to-r from-blue-600/5 to-purple-600/5" data-testid="getting-started">
      <CardContent className="p-5 space-y-4">
        <div>
          <p className="text-base font-bold">Primeiros Passos</p>
          <p className="text-xs text-muted-foreground mt-1">Complete as etapas abaixo para começar a operar</p>
        </div>
        <div className="space-y-2">
          {STEPS.map((step, i) => {
            const done = step.checkFn(stats);
            return (
              <button key={step.key} onClick={() => navigate(step.path)}
                className={`w-full flex items-center gap-3 p-3 rounded-lg text-left transition-colors ${done ? "bg-emerald-500/5 border border-emerald-500/10" : "bg-white/[0.02] border border-white/5 hover:bg-white/[0.04]"}`}>
                <div className={`w-8 h-8 rounded-full flex items-center justify-center shrink-0 ${done ? "bg-emerald-500/20" : "bg-white/10"}`}>
                  {done ? <Check className="w-4 h-4 text-emerald-400" /> : <span className="text-xs text-muted-foreground font-bold">{i + 1}</span>}
                </div>
                <div className="flex-1 min-w-0">
                  <p className={`text-sm font-medium ${done ? "text-emerald-400" : ""}`}>{step.label}</p>
                  <p className="text-xs text-muted-foreground">{step.desc}</p>
                </div>
                {!done && <ArrowRight className="w-4 h-4 text-muted-foreground shrink-0" />}
              </button>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
}
